"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeDisplaySubscriptionMobileMessaging = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var MobileMessaging = function (_a) {
    var onProceed = _a.onProceed;
    return (react_1.default.createElement("div", { className: "subscription__mobile-messaging" },
        react_1.default.createElement(kaleidoscope_1.SVG, { className: "space-stack-m", src: "/Assets/icons/block-crash.svg" }),
        react_1.default.createElement("div", { className: "subscription__mobile-messaging-heading" }, "Not optimised for mobile"),
        react_1.default.createElement("div", { className: "subscription__mobile-messaging-body" }, "Billing and subscription options aren't optimised for mobile devices. For the best experience, come back on a device with a bigger screen."),
        react_1.default.createElement("div", null,
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: onProceed }, "Proceed"))));
};
var maybeDisplaySubscriptionMobileMessaging = function (mountReactComponent, overlayStack, $timeout) {
    if (window.matchMedia && window.matchMedia("(max-width: 500px)").matches) {
        var onProceed = (0, lodash_1.once)(function () { return $timeout(overlayStack.closeCurrent); });
        overlayStack.add({
            contentUi: mountReactComponent(react_1.default.createElement(MobileMessaging, { onProceed: onProceed })),
            options: {},
        });
    }
};
exports.maybeDisplaySubscriptionMobileMessaging = maybeDisplaySubscriptionMobileMessaging;
